export const commonCardStyles = (theme) => {
  return {
    borderRadius: '8px',
    borderStyle: 'solid',
    borderWidth: '2px',
    borderColor: theme.palette.gray.dark,
    backgroundColor: theme.palette.background.default
  }
}
